export const en = {
  rebate_min_max: '$400 - $9,000',
};
